import { applyCoachLoadBalancing } from '../../utils/applyCoachLoadBalancing'
import {
  filterCoachesByStatus,
  getLocaleCompanyFilteredCoaches,
} from './filterCoaches'

/**
 * Locale/company coaches that legacy chat.js counted (presence chat or dnd).
 * Away coaches are ignored for busy / no-coaches missed-opportunity decisions.
 */
export function getLocaleListedCoaches(
  coaches,
  { userLocale, userCompanyId, partnerCandidate } = {},
) {
  return getLocaleCompanyFilteredCoaches(coaches, {
    userLocale,
    userCompanyId,
    partnerCandidate,
  }).filter((coach) => coach.status === 'chat' || coach.status === 'dnd')
}

/**
 * CTS-9955 / legacy showCoachesBusy: log a busy missed opportunity when the
 * candidate coach list has no free coaches (or none at all during hours).
 *
 * @returns {boolean} true if a missed opportunity was logged
 */
export function logBusyMissedOpportunity(
  candidateChatManager,
  coachList,
  { partnerCandidate, userLocale, userCompanyId, inHours } = {},
) {
  if (partnerCandidate || !candidateChatManager) return false

  const localeListed = getLocaleListedCoaches(coachList, {
    userLocale,
    userCompanyId,
    partnerCandidate,
  })
  const available = applyCoachLoadBalancing(
    filterCoachesByStatus(localeListed, 'chat'),
  )

  if (localeListed.length > 0 && available.length === 0) {
    candidateChatManager.logEvent('All coaches busy', {
      in_hours: inHours,
    })
    candidateChatManager.logMissedOpportunity('busy')
    return true
  }

  if (localeListed.length === 0 && inHours) {
    candidateChatManager.logEvent('No coaches available', {
      in_hours: inHours,
    })
    candidateChatManager.logMissedOpportunity('busy')
    return true
  }

  return false
}

/**
 * Whether the coach list still has no free (status=chat) coaches for this
 * candidate — used to start/clear the legacy 15s empty-list timer.
 */
export function hasNoAvailableLocaleCoaches(
  coachList,
  { userLocale, userCompanyId, partnerCandidate } = {},
) {
  const localeListed = getLocaleListedCoaches(coachList, {
    userLocale,
    userCompanyId,
    partnerCandidate,
  })
  const available = applyCoachLoadBalancing(
    filterCoachesByStatus(localeListed, 'chat'),
  )
  return available.length === 0
}
